import React, { useState } from 'react';
import '../styles/FriendRequestNotification.css';
import { FriendRequest } from '../types/friendRequest';
import { acceptFriendRequest, rejectFriendRequest } from '../services/friendService';

interface FriendRequestNotificationProps {
  requests: FriendRequest[];
  onClose: () => void;
  onUpdate: () => void;
}

const FriendRequestNotification: React.FC<FriendRequestNotificationProps> = ({
  requests,
  onClose,
  onUpdate
}) => {
  const [processing, setProcessing] = useState<string | null>(null);

  if (requests.length === 0) {
    return null;
  }

  const handleAccept = async (requestId: string) => {
    try {
      setProcessing(requestId);
      await acceptFriendRequest(requestId);
      onUpdate();
    } catch (error) {
      console.error('Error accepting friend request:', error);
      alert('Fejl ved accept af anmodning');
    } finally {
      setProcessing(null);
    }
  };

  const handleReject = async (requestId: string) => {
    try {
      setProcessing(requestId);
      await rejectFriendRequest(requestId);
      onUpdate();
    } catch (error) {
      console.error('Error rejecting friend request:', error);
      alert('Fejl ved afvisning af anmodning');
    } finally {
      setProcessing(null);
    }
  };

  return (
    <div className="friend-request-notification-overlay">
      <div className="friend-request-notification-modal">
        <div className="friend-request-notification-header">
          <h2>Venneanmodninger</h2>
          <button 
            className="friend-request-notification-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="friend-request-notification-content">
          {requests.map((request) => (
            <div key={request.id} className="friend-request-item">
              <p className="friend-request-text">
                <strong>{request.senderUsername}</strong> har sendt dig en anmodning
              </p>
              <div className="friend-request-actions">
                <button
                  onClick={() => handleAccept(request.id)}
                  className="friend-request-accept-btn"
                  disabled={processing === request.id}
                >
                  Accepter
                </button>
                <button
                  onClick={() => handleReject(request.id)}
                  className="friend-request-reject-btn"
                  disabled={processing === request.id}
                >
                  Afvis
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FriendRequestNotification;
